export enum FeaturesCodes {
	ENFORCE_CREDITS = "ENFORCE_CREDITS",
	IRL_COUNTRIES_SUM = "IRL_COUNTRIES_SUM",
	SELF_REGISTER = "SELF_REGISTER",
	SHOW_CREDITS = "SHOW_CREDITS",
	LEAD_SCORING = "LEAD_SCORING",
	SEQUENCER = "SEQUENCER",
	AI_SNIPPET = "AI_SNIPPET",
	TEMPLATES = "TEMPLATES",
	HUBSPOT = "HUBSPOT",
	ZOHO_CRM = "ZOHO_CRM",
	PIPEDRIVE_CRM = "PIPEDRIVE_CRM",
	MSDYNAMICS_CRM = "MSDYNAMICS_CRM",
	SALESFORCE_CRM = "SALESFORCE_CRM",
	TRACKER_AS_LIST = "TRACKER_AS_LIST",
	DEEP_RESEARCH = "DEEP_RESEARCH",
	KNOWLEDGE_DB = "KNOWLEDGE_DB",
	NOTIFICATION_CENTER = "NOTIFICATION_CENTER",
	CONTACT = "CONTACT",
	ORGANIZATION = "ORGANIZATION",
	CONNECTION_SYNC = "CONNECTION_SYNC",
	FEATURE_ONBOARDING = "FEATURE_ONBOARDING",
	SMART_LIST = "SMART_LIST",
	COPYWRITING_SETTINGS = "COPYWRITING_SETTINGS",
	LI_CONNECTIONS_ENRICHMENT = "LI_CONNECTIONS_ENRICHMENT",
	MCP_ACCESS = "MCP_ACCESS",
	HELP_CENTER = "HELP_CENTER",
	JOB_TITLE_SCREENING = "JOB_TITLE_SCREENING",
	EXTENSION_PROMOTION = "EXTENSION_PROMOTION",
	CAMPAIGNS_OVERVIEW = "CAMPAIGNS_OVERVIEW",
	SUPPORT_TICKETS = "SUPPORT_TICKETS",
}
